import React from 'react';
import styled from 'styled-components';

import BlogIndexPage from '../components/blog/blog-index-page';
import Layout from '../components/layout';
import SEO from '../components/seo';

const BlogContainer = styled.div``;

const Blog = ({ location }) => {
    return (
        <Layout>
            <SEO title="Blog" />
            <BlogContainer>
                <BlogIndexPage location={location} />
            </BlogContainer>
        </Layout>
    );
};

export default Blog;
